import { Keys } from "../schema";
import { Context, Effect, Schema, pipe } from "effect";
import Stripe from "stripe";
import { StripeApiConfigurationError } from "./StripeApiBaseClient";
import { SecretUnsealerService } from "@open-revenue/utils/secrets";
// This should be removed in favor of StripeApiInstanceBuilder
export class StripeApiInstance extends Context.Tag("@open-revenue/stripe/StripeApiInstance")() {
    static make = (apiKey)=>Effect.succeed(new Stripe(apiKey));
    static makeSealed = (apiKey)=>pipe(Schema.decode(Keys.KeysSealed)(apiKey), Effect.mapError((e)=>new StripeApiConfigurationError(e)), Effect.tap((_)=>SecretUnsealerService), Effect.flatMap((apiKey)=>StripeApiInstance.make(apiKey)));
}
